import React, { Component } from 'react';
import ConfiguratorSection from './../ConfiguratorSection';
import ConfiguratorImage from './../ConfiguratorImage';
import ConfiguratorOption from './../ConfiguratorOption';
import { withTranslation, Trans } from 'react-i18next';
import Toggle from '../Toggle';
import { exterior_view05ImageOptions } from './views/exterior_view05'

class Xc47BathingPlatform extends Component {
    constructor(props) {
        super(props);
        this.handlePlatformChange = this.handlePlatformChange.bind(this);
        this.handleGangwayChange = this.handleGangwayChange.bind(this);
    }

    handlePlatformChange(event) {
        let configuration = this.props.configuration;
        configuration.DavidsRib = event.target.checked ?
            { value: 2, label: 'true' } :
            { value: 1, label: 'false' };

        if (this.props.onChange) {
            this.props.onChange(configuration);
        }
    }

    handleGangwayChange(event) {
        let configuration = this.props.configuration;
        configuration.RemovableGangway = event.target.checked ? { value: 2, label: 'true' } : { value: 1, label: 'false' };

        if (this.props.onChange) {
            this.props.onChange(configuration);
        }
    }


    render() {
        let imageOptions = exterior_view05ImageOptions;

        let image = (
            <ConfiguratorImage boat="Xc47" configuration={this.props.configuration} options={imageOptions} />
        );

        return (
            <ConfiguratorSection image={image}>

                <ConfiguratorOption>

                    <h1><Trans defaults='Bathing platform' /></h1>
                    
                    <p><Trans defaults='As standard, the bathing platform is operated electrically with two actuators, integrated attachment for “hang on” bathing ladder with teak steps and a walk-through passageway with moulded steps from cockpit level down to platform.' /></p>

                    <Toggle checked={this.props.configuration.DavidsRib.value === 2} onChange={this.handlePlatformChange}>
                        <Trans defaults='Davids system for RIB integrated with bathing platform.' />
                    </Toggle>

                    <Toggle
                        checked={this.props.configuration.RemovableGangway.value === 2}
                        onChange={this.handleGangwayChange}
                    >
                        <Trans defaults='Manual removable carbon gangway (260 cm)' />
                    </Toggle>



                </ConfiguratorOption>
            </ConfiguratorSection>
        );
    }
}

export default withTranslation()(Xc47BathingPlatform);


// WEBPACK FOOTER //
// ./src/Xc47/Xc47BathingPlatform.js